import HomeOutlineIcon from '@eduzz/houston-icons/HomeOutline';
import HoustonBreadcrumb from '@eduzz/houston-ui/Breadcrumb';
import * as React from 'react';
import { NavLink } from 'react-router-dom';

const { Item, Link } = HoustonBreadcrumb;

function Breadcrumb() {
  return (
    <HoustonBreadcrumb>
      <Link id='breadcrumb-home-link' as={NavLink} to='/producer/dashboard' icon={<HomeOutlineIcon />} />
      <Link id='breadcrumb-bank-data-link' as={NavLink} to='/producer/profile/bankdata'>
        Contas bancárias
      </Link>
      <Item>Cadastro de conta bancária</Item>
    </HoustonBreadcrumb>
  );
}

export { Breadcrumb };
